import styled, { keyframes } from 'styled-components';




const fadeFromLeft = keyframes`
from {
  opacity: 0;
  transform:translateX(50) ;
}
to{
  opacity: 1;
  transform:translateX(0);
}
`;

const rotateSmoth = keyframes`
from {

  transform: rotateX(0deg) ;
}
to{
  transform: rotateX(20deg) ;
}
`;

interface IBackground {
  background?: string;
}

export const Container = styled.div<IBackground>`
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: #006633;
  color: #fff;
  padding: 0px;
  width: 100%;
position: relative;
 

  >a {
    transition: 5s all;
    >img{
      transition: 5s all;
    }
  }

  .tenda_back {
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    margin: 5px;
    padding: 5px;
    border: 2px solid #fff;
    color: #fff;

    transition: 0.5s all;

    &:hover{
      background: #ff6600;
    }
  }

  .title_div{
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 20px;
  }

.tenda_title {
  width: 100%;
   max-width: 200px;
   max-height: 50px;

}


.tenda_ground_div{
  position: fixed;
  z-index: 0;
  bottom: 0;
  right: 0;
  width: 30%;
  z-index: 0;

  img.tenda_ground{
      width: 100%;
    }

    img.tenda_image {
      position: absolute;
      right: 15%;
      width: 60%;
      bottom: 10%;
    }

  >div {
    width: 100%;
    position: relative;

  
  }
}

div.photoContainer{
 
  border: 3px solid #fff;
  border-radius:10px
}

`;
